export const url = "https://gosupersquad.com:5005/";
